// extracted by mini-css-extract-plugin
export default {"expressCheckoutSection":"_C-z","expressButtonContainerWithPayPal":"aD-z","expressButton":"bD-z","or":"cD-z"};